import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import ja from './locales/ja'

Vue.use(VueI18n)

const messages = {
  en,
  ja
}

const i18n = new VueI18n({
  locale: 'ja', // Set default locale to Japanese
  fallbackLocale: 'en',
  messages
})

export default i18n
